import { Grid } from "@mui/material";
import LocationBox from "../components/LocationBox";
import ContactCard from "../components/ContactCard";

function ContactPage() {
  return (
    <Grid container spacing={0} columns={12}>
        {/* Google maps location */}
        <Grid size={{ xs: 12, md: 6 }} order={{ xs: 2, lg: 1 }}>
          <LocationBox />
        </Grid>

        {/* Contact Form */}
        <Grid size={{ xs: 12, md: 6 }} order={{ xs: 1, lg: 2 }}>
          <ContactCard />
        </Grid>
    </Grid>    
  )
}

export default ContactPage;